﻿{
  "version": 1,
  "gameId": "xo",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "xo.rules.navigationLabel",
    "kickerKey": "xo.rules.kicker",
    "titleKey": "xo.rules.title",
    "summaryKey": "xo.rules.summary",
    "sections": [
      { "id": "setup", "key": "xo.rules.setup" },
      { "id": "turn", "key": "xo.rules.turn" },
      { "id": "win", "key": "xo.rules.win" },
      { "id": "rolling", "key": "xo.rules.rolling" },
      { "id": "modes", "key": "xo.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {}
}
